<template>
    <div>
        <p><strong>Paid Outside Rebilly</strong></p>
        <p class="text-muted" v-if="instrument.receivedBy">{{instrument.receivedBy}}</p>
    </div>
</template>

<script>
    import {vIcon} from '@/components/form';

    export default {
        name: 'paid-outside-view',
        components: {vIcon},
        props: {
            instrument: Object,
            isCompact: {
                type: Boolean,
                default: true,
            },
        },
    };
</script>
